export default "__VITE_ASSET__BBtkGyEl__"